import { StyleProp, ViewStyle } from 'react-native';
import { MBTextBody1 } from '@shared/components/typography';
import { AddressField } from '@shared/data/entity/fields/AddressField';
import { Colors, grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: AddressField;
  style: StyleProp<ViewStyle>;
}

const addressStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(1),
};

export function AddressCollectionViewField({ field, style }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[addressStyles, style]}>
      <MBTextBody1>{field.address.title}</MBTextBody1>
      <MBTextBody1 color={Colors.v2.gray50}>{field.address.subtitle}</MBTextBody1>
    </CardCollectionViewFieldContainer>
  );
}
